import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {Box, Button, Modal} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import api from "../../../api";
import classNames from "classnames";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '3px',
    maxWidth: '90%',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto'
};

const ModalElement = ({open, onClose, data, setPage, confirm, token, id, newData, setNewData, status}) => {
    const [loading, setLoading] = useState(true)

    const getData = async () => {
        try {
            setLoading(true)
            const res = await api().post(`coach/synchro/update_result/${id}/${token}`)
            setNewData(res.data)
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        getData()
    }, [])

    const total = data.reduce((acc, curr) => {
        return acc += +curr.value
    }, 0)

    return (
        <Modal
            open={open}
            // onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {!loading && <>
                    {status === 'wait' ?
                        <h1 className={s.title}>Ожидайте перехода на следующую команду</h1> :
                        <h1 className={s.title}>Подтвердите ввод оценок</h1>}

                    <div className={s.wrapper}>
                        <div className={s.content}>
                            <div className={s.result_value}>
                                <div className={classNames(s.result_item, newData?.score_synchro?.find((f) => f.synchro_type_id === 1)?.value?.toFixed(2) && s.green)}>
                                    {newData?.score_synchro?.find((f) => f.synchro_type_id === 1)?.value?.toFixed(2)}
                                </div>
                                <div className={classNames(s.result_item, newData?.score_synchro?.find((f) => f.synchro_type_id === 3)?.value?.toFixed(2) && s.red)}>
                                    {newData?.score_synchro?.find((f) => f.synchro_type_id === 3)?.value?.toFixed(2)}
                                </div>
                                <div className={classNames(s.result_item, newData?.score_synchro?.find((f) => f.synchro_type_id === 2)?.value?.toFixed(2) && s.yellow)}>
                                    {newData?.score_synchro?.find((f) => f.synchro_type_id === 2)?.value?.toFixed(2)}
                                </div>
                            </div>
                        </div>

                        <div className={s.result_total}>
                            <p>Итого</p>
                            <div>{newData?.score_result?.toFixed(2)}</div>
                        </div>
                    </div>

                    <div className={s.btns} style={{display: status === 'wait' ? 'none' : 'flex'}}>
                        <Button variant="outlined" color="error" onClick={onClose}>
                            <CloseIcon sx={{fontSize: 40}}/>
                        </Button>
                        <Button variant="contained" onClick={confirm} sx={{marginLeft: '100px'}}>
                            <CheckIcon sx={{fontSize: 40}}/>
                        </Button>
                    </div>
                </>}
            </Box>
        </Modal>
    );
};

export default ModalElement;
